/**
 * @constructor
 * @extends {Foundation.Component}
 * @param {string} id
 */
Foundation.Login.Dialog.LinkAccountComponent = function (id) {
    Foundation.Component.call(this, id);

    /**
     * Keep track of whether or not the dialog getting closed means the user
     * doesn't actually want to log in with Facebook any more. In other words,
     * if they close the dialog intentionally they don't want to sign in to FB.
     * If the dialog closes because they submitted the form successfully, then
     * they do want to log in to FB.
     * @private
     * @type {boolean}
     */
    this._dialogClosureMeansUserCanceledLogIn = true;

    /**
     * @private
     * @type {Foundation.Login.ThirdPartyAuthenticator}
     */
    this._authenticator = null;

    /**
     * private
     * @type {Foundation.Form}
     */
    this.form = this.registerForm(new Foundation.Form(this.view.find("form")[0]));
    this.form.setSubmitDelegate(this._logInAndLinkAccount.bind(this));
    this.observe("hidden", this.form.cancelSubmit.bind(this.form));

    this.observe("shown", (function () {
        this._authenticator = Foundation.Login.Dialog.activeDialog.authenticator();
        var member = Foundation.Login.Dialog.activeDialog.member();
        this.view.find("input[name=email]").val(member.get("email"));
        this.view.find("span[data-view-label=service-name]").html(this._authenticator.serviceName())
        Foundation.Login.Dialog.activeDialog.closed().then(this._dialogHasClosed.bind(this));
    }).bind(this));
};
Foundation.inherit(Foundation.Login.Dialog.LinkAccountComponent, Foundation.Component);

/**
 * @param {Object.<string,*>} vals
 * @return {!Foundation.Promise}
 */
Foundation.Login.Dialog.LinkAccountComponent.prototype._logInAndLinkAccount = function (vals) {
    var commit = new Foundation.Promise();

    this._dialogClosureMeansUserCanceledLogIn = false;

    var member = Foundation.Login.Dialog.activeDialog.member()
    member.set("email", vals["email"]);

    var attempt = new Foundation.Login.Attempt(member)
    attempt.forEmail(/** @type {string} */ (vals["email"]))
    attempt.withPassword(/** @type {string} */ (vals["password"]))
    var result = attempt.performAttempt()
        .then(function () {
            var decoration = this._authenticator.decorateMember(member);
            decoration.then(function () {
                commit.marry(this._authenticator.linkLoggedInMemberWithThirdPartyCredentials());
            }.bind(this), function () {
                commit.marry(decoration);
            }.bind(this));
        }.bind(this))
        .otherwise(function () {
            commit.marry(result);
        }.bind(this));

    commit.otherwise(function () {
        this._dialogClosureMeansUserCanceledLogIn = true;
    }.bind(this));

    return commit;
};

/**
 * Called when the user closes the dialog box or the dialog box gets closed when
 * the user successfully logged in.
 * @private
 */
Foundation.Login.Dialog.LinkAccountComponent.prototype._dialogHasClosed = function () {
    if (this._dialogClosureMeansUserCanceledLogIn) {
        this._authenticator.userCanceledAccountCreation();
    }
};
